export const defaultPin = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.9546 9.977C20.9546 5.026 16.9266 1 11.9766 1C7.02757 1 2.99957 5.026 2.99957 9.977C2.99957 16 11.9766 22.643 11.9766 22.643C11.9766 22.643 20.9546 16 20.9546 9.977Z" fill="#9A8EF2"/>
    <path d="M16.0636 10.0997C16.0636 7.8457 14.2306 6.0127 11.9766 6.0127C9.72362 6.0127 7.89062 7.8457 7.89062 10.0997C7.89062 12.3527 9.72362 14.1857 11.9766 14.1857C14.2306 14.1857 16.0636 12.3527 16.0636 10.0997Z" fill="#F7F7F7"/>
</svg>
`;
